export default __webpack_public_path__ + "static/media/bw-working-memory-tutorial-pop-up-step-1.000acca5.svg";